import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

export default function popupHOC (WrappedComponent) {
  class CompWithPopup extends Component {
    state = {
      isOpen: false
    };

    handleClickOutside = () => {
      this.setState({
        isOpen: false
      });
    };

    toggleMenu = e => {
      e.stopPropagation();
      this.setState((prevState) => ({
        isOpen: !prevState.isOpen
      }));
    };

    closeMenu = () => {
      this.setState({
        isOpen: false
      });
    };

    openMenu = () => {
      this.setState({
        isOpen: true
      });
    };

    render () {
      return (
        <WrappedComponent
          {...this.props}
          isOpen={this.state.isOpen}
          toggleMenu={this.toggleMenu}
          closeMenu={this.closeMenu}
          openMenu={this.openMenu}
        />
      );
    }
  }

  return onClickOutside(CompWithPopup);
}



// WEBPACK FOOTER //
// ./src/components/common/popupHOC.js